export enum CountryCode {
  MEXICO = '+52',
}
